<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="white",
      absolute,
      top
    )
    v-row.text-center(v-if="!entity")
      v-col.py-0
        h2.primary--text No entity selected
        small.white--text Select an entity from the sidebar list.
    v-row(v-else)
      v-col.py-0
        v-card.px-10.py-5.my-5.body--content
          v-overlay(absolute, v-if="loading")
          g-data-table(
            :headers="$fieldsToHeaders(entity, $fields(entity, 'primitive'))",
            :items="pagination.data",
            :options.sync="options",
            :server-items-length="pagination.total",
            data-cy="index__table",
            v-bind="{ loading }",
          )
            template(v-slot:no-data)
              h2 {{ $replaceUnderscoreToSpace($pascalToHuman(entityName)) }} doesn't have items
              small Create an item for this entity or change search criteria.
            template(v-slot:top)
              v-row.table__top
                v-col.py-0
                  app-entity-search(
                    :criteria="$getInitialCriterias($route.params.criteria, pagination.where)",
                    @pagination="pagination = $event",
                    :loads="loads",
                    :entity="entity",
                    :rowsPerPage="options.itemsPerPage || null",
                    :endpoint="envEndpoint",
                    data-cy="index__searcher",
                  )
                v-col.pt-4.text-right(v-if="ShowEntityCreate(entityName) && createConfig(entityName)" cols="auto")
                  v-tooltip(left)
                    template(v-slot:activator="{ on }")
                      g-btn.h8(
                        color="primary",
                        v-on="on",
                        link,
                        @click.native="$savePaginationAndRoute(entityName, pagination, options, `/${$scope()}/${entityName}/add`)",
                        data-cy="index__create",
                      ) Create new
                    span Add {{ $replaceUnderscoreToSpace($pascalToHuman(entityName)) }}
            template(v-slot:item.action="{ item }")
              .d-flex.justify-center
                a(
                  v-if="ShowEntityEdit(entityName)",
                  style="text-decoration: none",
                  @click="$savePaginationAndRoute(entityName, pagination, options, `/${$scope()}/${entityName}/${getEditAttribute(item)}/edit`)",
                )
                  v-icon.primary--text(small) mdi-pencil
                router-link(
                  v-if="ShowEntityView(entityName) && !ShowEntityEdit(entityName)",
                  style="text-decoration: none",
                  :to="`/${$scope()}/${entityName}/${getEditAttribute(item)}/view`"
                )
                  v-icon.primary--text(small) mdi-eye

                app-entity-delete(:title="item.name || entityName", @confirm="remove(item)", v-if="ShowEntityDelete(entityName)")
                  template(v-slot:btn="{ on }")
                    v-icon(small, color="#E3476C", v-on="on") mdi-delete
    v-row
      v-snackbar(v-model="snackbar")
        | {{ message }}
        v-btn(color="pink", text, @click="snackbar = false")
</template>

<style type="scss" scoped>
.g-data-table {
  min-height: 65vh;
}

.g-data-table .row.table__top {
  flex-grow: 0;
}

.v-data-table td {
  white-space: nowrap;
}
.top-right {
  position: absolute;
  top: 1rem;
  right: .5rem;
}
.body--content {
  box-shadow: 3px 7px 30px rgba(0, 0, 0, 0.06) !important;
  border-radius: 8px !important;
}
</style>

<script>
import axios from 'axios'
import keys from 'lodash/keys'
import { AppEntityDelete } from '@@/components'
import AppEntityAutocomplete from '@@/components/EntityAutocomplete.vue'
import EntiyLoadsMixin from "@/mixins/entity-loads.mixin";
import IndexFilterMixin from '@/mixins/index-filter.mixin';

export default {
  components: {
    AppEntityDelete,
    AppEntityAutocomplete
  },
  name: 'entity-index',
  mixins: [
    EntiyLoadsMixin,
    IndexFilterMixin,
  ],
  data: () => ({
    message: '',
    snackbar: false,
    loading: false,
    timer: null,
    wait: 500,
    pagination: {
      where: [],
    },
    options: {},
    loads: [],
    envEndpoint: null,
  }),

  watch: {
    $route: {
      immediate: true,
      handler () {
        this.clear();
        this.loads = _.get(ENV.ENTITIES, `${this.entityName}.index.add`, [])
          .filter(x => x.load)
          .map(x => x.load);
        this.load(this.options);
      }
    },
    options: {
      handler (options) {
        this.load(options)
      }
    }
  },

  computed: {
    has() {
      return !!this.items.length
    },
    entityName() {
      return 'Group'
    },
    entity() {
      return this.$searchEntity(this.entityName, 'name')
    },
  },
  methods: {
    getPagination(options = null, where = null) {
      options = options || this.options
      if (!keys(options).length) return
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: options.sortBy[0],
          desc: options.sortDesc[0],
          where: where,
        }
      }
    },
    /* TODO: docs */
    async load (options = null) {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        const pagination = this.getPagination(options, this.pagination.where)
        if (this.entity) {
          this.loading = true
          var criteria = this.$route.params.criteria ? { Where: [this.$route.params.criteria.value] } : null
          pagination.params = {...pagination.params, ...criteria}
          try {
            const envParams = _.get(ENV.ENTITIES, this.entityName  + '.index.params', {});
            pagination.params = _.merge(pagination.params, envParams);
            const paginationresult = (await axios.get(this.$fetchLoad(this.envEndpoint || this.entityName, !this.envEndpoint, ...this.loads), pagination)).data;
            paginationresult.data = (paginationresult.data || []).map(d => ({
              // The date should be a UTC format, otherwise it's not going to work.
              ...d,
              // TODO: implement env ignoreTimezone here, find a way to make it generic.
              //createdAt: this.$formattedDate(d.createdAt),
            }));
            this.pagination = paginationresult;
          } catch (err) {}
          this.loading = false
        }
      }, this.wait)
    },

    /* TODO: docs */
    async remove (entity) {
      this.loading = true
      entity.entityState = ENV.ENTITY.STATE.DELETED
      try {
        await axios.post('entity/graph', entity)
      } catch (e) {
        this.snackbar = true
        this.message = e.response && e.response.data.message
      }
      await this.load(this.options)
      this.$updateSchema(this.$store, axios)
    },

    getEditAttribute(item) {
      return _.get(item, _.get(ENV.ENTITIES, this.entityName  + '.index.editAttribute', 'uid'));
    },
    clear () {
      this.options = {
        ...this.options,
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      };
      this.pagination.where = null;
    },
    createConfig(entityName) {
      return !_.get(ENV.ENTITIES, entityName + '.index.noCreate', false);
    },
    getSavedPagination() {
      const { pagination, options } = this.$getSavedPagination(this.entityName);
      if(pagination && options) {
        this.pagination = pagination;
        this.options = options;
        this.load(this.options);
      }
    },
  },
  created() {
    this.envEndpoint = _.get(ENV.ENTITIES, this.entityName  + '.index.endpoint');
    this.getSavedPagination();
  }
}
</script>
